import { HelpOutline } from '@mui/icons-material';
import { Dialog, DialogContent, Divider, Paper } from '@mui/material';
import { PaperProps } from '@mui/material/Paper/Paper';
import { uniqueId } from 'lodash';
import React, { useState } from 'react';
import Draggable from 'react-draggable';

import { SolaForceDialogTitle } from '~/components/SolaForceDialogTitle';

import { useSxStyles } from './useStyles';

export type HelpDialogProps = {
  open: boolean;
  title: string;
  children?: React.ReactNode;
  onClose: () => void;
};

export const HelpDialog = (props: HelpDialogProps) => {
  const { open, title, children, onClose } = props;
  const sxStyles = useSxStyles();

  const [dialogId] = useState(uniqueId('draggable-dialog-'));

  const DraggableDialogPaperComponent = (paperProps: PaperProps) => {
    return (
      <Draggable
        handle={`#${dialogId}`}
        cancel={'[class*="MuiDialogContent-root"]'}
      >
        <Paper {...paperProps} />
      </Draggable>
    );
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={'xl'}
      PaperComponent={DraggableDialogPaperComponent}
      PaperProps={{
        style: sxStyles.dialogSize,
      }}
      aria-labelledby={dialogId}
    >
      <SolaForceDialogTitle
        icon={<HelpOutline />}
        onClose={onClose}
        id={dialogId}
      >
        {title}
      </SolaForceDialogTitle>
      <Divider />
      <DialogContent>{children}</DialogContent>
    </Dialog>
  );
};
